"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProductItem = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _server = babelHelpers.interopRequireDefault(require("react-dom/server"));

var _text = babelHelpers.interopRequireDefault(require("components/field/text"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _animationHelper = babelHelpers.interopRequireDefault(require("animation-helper"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _emailSignup = babelHelpers.interopRequireDefault(require("email-signup"));

var _decorators = require("decorators");

var _class;

var ProductItem =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ProductItem, _Component);

  function ProductItem() {
    babelHelpers.classCallCheck(this, ProductItem);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(ProductItem).apply(this, arguments));
  }

  babelHelpers.createClass(ProductItem, [{
    key: "imageURL",
    value: function imageURL() {
      return "/t/width=300/height=300/matte=fff0/scale/f".concat(this.props.product.image_name, "/thumb.jpg");
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("a", {
        href: this.link(),
        className: "product-grid-item"
      }, _react.default.createElement("div", {
        className: "product-image",
        style: {
          backgroundImage: "url(".concat(this.imageURL(), ")")
        }
      }), _react.default.createElement("p", null, this.props.product.title));
    }
  }, {
    key: "link",
    value: function link() {
      return this.props.product.link;
    }
  }]);
  return ProductItem;
}(_react.Component);

exports.ProductItem = ProductItem;
;

var ProductList =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(ProductList, _Component2);

  function ProductList(props) {
    var _this;

    babelHelpers.classCallCheck(this, ProductList);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(ProductList).call(this, props));
    _this.state = {
      selectedGroup: null
    };

    if (!ProductList.recordsForGroups[props.group]) {
      if (_exports.default.Channel) {
        if (/^search:/.test(props.group)) {
          var query = props.group.substring('search:'.length);

          var search = _exports.default.Channel.tools.products.lwp('search', {
            query: query
          }).records;

          var RR = _exports.default.Channel.tools.products.getRecords(search);

          ProductList.recordsForGroups[props.group] = search.map(function (id) {
            return RR[id];
          }).filter(function (v) {
            return !!v;
          }).map(function (record) {
            return {
              id: record.id,
              title: record.title,
              image_name: record.image_name,
              seo_url: record.seo_url,
              link: _exports.default.Link('product-detail', record)
            };
          });
          _this.state.selectedGroup = props.group;
        } else {
          var group = _exports.default.Channel.tools.products.groups[props.group];
          ProductList.recordsForGroups[props.group] = [].map.call(group.records, function (record) {
            return {
              id: record.id,
              title: record.title,
              image_name: record.image_name,
              seo_url: record.seo_url,
              link: _exports.default.Link('product-detail', {
                record: record,
                group: group
              })
            };
          });
          _this.state.selectedGroup = props.group;
        }
      }
    } else {
      _this.state.selectedGroup = props.group;
    }

    return _this;
  }

  babelHelpers.createClass(ProductList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentDidUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      if (!this.state.selectedGroup || this.state.selectedGroup != this.props.group) {
        if (ProductList.recordsForGroups[this.props.group]) {
          this.setState({
            selectedGroup: this.props.group
          });
        } else {
          this.loadRecords().then(function (data) {
            ProductList.recordsForGroups[_this2.props.group] = data;

            _this2.setState({
              selectedGroup: _this2.props.group
            });
          });
        }
      }
    }
  }, {
    key: "loadRecords",
    value: function loadRecords() {
      var _this3 = this;

      return new Promise(function (resolve) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', "data/products?group=".concat(_this3.props.group), true);

        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4) {
            resolve(JSON.parse(xhr.responseText));
          }
        };

        xhr.send();
      });
    }
  }, {
    key: "childGroups",
    value: function childGroups() {
      var _this4 = this;

      var X = Object.keys(this.props.groups).map(function (id) {
        return _this4.props.groups[id];
      }).filter(function (group) {
        return group.parent_group_id == _this4.props.group;
      });
      X.sort(function (left, right) {
        return left.display_order - right.display_order;
      });
      return X;
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var itemList = ProductList.recordsForGroups[this.props.group] || [];
      return _react.default.createElement("section", {
        className: "product-group"
      }, this.props.top ? _react.default.createElement("header", {
        className: itemList.length ? 'mobile-header visible' : 'mobile-header'
      }, _react.default.createElement("a", {
        className: "mobile-nav-button",
        onClick: this.props.mobileNavToggle
      }), this.props.groups[this.props.group].title) : null, !this.props.top && itemList.length ? _react.default.createElement("header", null, this.props.groups[this.props.group].title) : null, itemList.length ? _react.default.createElement("section", {
        className: "product-grid"
      }, itemList.map(function (item) {
        return _react.default.createElement(ProductItem, {
          key: item.id,
          product: item,
          group: _this5.props.group,
          groups: _this5.props.groups
        });
      })) : null, this.childGroups().map(function (group) {
        return _react.default.createElement(ProductList, {
          group: group.id,
          groups: _this5.props.groups,
          key: group.id
        });
      }));
    }
  }]);
  return ProductList;
}(_react.Component);

ProductList.recordsForGroups = {};
var App = (_class =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(App, _Component3);
  babelHelpers.createClass(App, null, [{
    key: "filter",
    value: function filter(group) {
      return {
        id: group.id,
        parent_group_id: group.parent_group_id || null,
        display_order: Number(group.display_order),
        file_name: group.file_name,
        title: group.title,
        seo_url: group.seo_url,
        description: group.description
      };
    }
  }, {
    key: "serverRender",
    value: function serverRender(page, productGroup, defaultProductGroup, queryData) {
      var _this7 = this;

      var groupList = {};
      var app = _exports.default.Channel.tools.products;
      var appGroups = app.lwp('find', {
        $group: true,
        deleted: 0
      }).records;
      appGroups.forEach(function (id) {
        return groupList[id] = _this7.filter(app.groups[id]);
      });

      if (queryData.q) {
        productGroup = this.getSearchGroup(queryData.q);
        groupList[productGroup.id] = productGroup;
      }

      return "\n\t\t\t<div data-component=\"ProductList\">".concat(_server.default.renderToString(_react.default.createElement(App, {
        defaultGroup: defaultProductGroup.id,
        group: (productGroup || defaultProductGroup).id,
        groups: groupList
      })), "</div>\n\t\t\t<script id=\"ProductData\" type=\"application/json\">").concat(JSON.stringify({
        groups: groupList,
        productList: ProductList.recordsForGroups,
        productGroup: (productGroup || defaultProductGroup).id,
        defaultGroup: defaultProductGroup.id
      }, null, 4), "</script>\n\t\t\t").concat(page.inlineScript("\n\t\t\t\tvar F = document.getElementById('ProductData').textContent;\n\t\t\t\tvar D = JSON.parse(F);\n\t\t\t\tvar C = require('products/app').default;\n\t\t\t\tC.clientRender(this.querySelector('[data-component=ProductList]'), D.productList, D.groups, D.productGroup, D.defaultGroup);\n\t\t\t"), "\n\t\t");
    }
  }, {
    key: "clientRender",
    value: function clientRender(node, productList, groups, productGroup, defaultGroup) {
      ProductList.recordsForGroups = productList;

      _reactDom.default.render(_react.default.createElement(App, {
        group: productGroup,
        groups: groups,
        defaultGroup: defaultGroup
      }), node);
    }
  }]);

  function App(props) {
    var _this6;

    babelHelpers.classCallCheck(this, App);
    _this6 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(App).call(this, props));
    _this6.state = {
      groups: Object.assign({}, _this6.props.groups),
      selectedGroup: props.group,
      previousGroup: null,
      mobileNavOpen: false
    };
    if (props.groups[props.group].isSearch) _this6.state.searchText = props.groups[props.group].searchText;
    _this6.popState = _this6.popState.bind(babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    _this6.fadeOutPrevious = _this6.fadeOutPrevious.bind(babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    return _this6;
  }

  babelHelpers.createClass(App, [{
    key: "getSearchGroup",
    value: function getSearchGroup(query) {
      return App.getSearchGroup(query);
    }
  }, {
    key: "createSearchGroup",
    value: function createSearchGroup(callback) {
      if (this.state.groups["search:".concat(this.searchQuery)]) {
        callback(this.state.groups["search:".concat(this.searchQuery)]);
        return;
      }

      var searchGroup = this.getSearchGroup(this.searchQuery);
      this.setState(function (state) {
        var T = Object.assign({}, state.groups, babelHelpers.defineProperty({}, searchGroup.id, searchGroup));
        return state;
      }, function () {
        return callback(searchGroup);
      });
    }
  }, {
    key: "childGroups",
    value: function childGroups(id) {
      var _this8 = this;

      var top = Object.keys(this.state.groups).map(function (id) {
        return _this8.state.groups[id];
      }).filter(function (group) {
        return !group.isSearch && group.parent_group_id == id;
      });
      top.sort(function (left, right) {
        return Number(left.display_order) - Number(right.display_order);
      });
      return top;
    }
  }, {
    key: "mobileNavToggle",
    value: function mobileNavToggle() {
      this.setState(function (state) {
        return {
          mobileNavOpen: !state.mobileNavOpen
        };
      });
    }
  }, {
    key: "gotPageHeader",
    value: function gotPageHeader(node) {
      this.pageHeader = node;
    }
  }, {
    key: "gotNav",
    value: function gotNav(nav) {
      this.nav = nav;
    }
  }, {
    key: "gotProductContent",
    value: function gotProductContent(content) {
      this.productContent = content;
    }
  }, {
    key: "description",
    value: function description(text) {
      if (text.indexOf('<') == -1) return "<p>".concat(text, "</p>");
      return text;
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      return _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "large-header vertical-detail",
        style: {
          backgroundImage: "linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, .0)), \n\t\t\t\t\t\turl(".concat((this.group || {}).file_name || '/admin/platform/plugins/com.sightworks.5.Channel.instance.marketing/resources/images/tpash-bg-product2-1200x788.jpg', ")")
        }
      }, _react.default.createElement("div", {
        className: "inner-content col-md-8",
        ref: this.gotPageHeader
      }, null
      /* <h3 className='uppercase'>
      Shop
      </h3> */
      , _react.default.createElement("h1", {
        className: "uppercase"
      }, this.group ? this.group.title : 'All Products'), false && this.group && this.group.description ? _react.default.createElement("div", {
        className: "description",
        dangerouslySetInnerHTML: {
          __html: this.description(this.group.description)
        }
      }) : null, false && _react.default.createElement("button", {
        className: "btn btn-pink",
        onClick: this.scrollIntoView
      }, "Start Shopping"))), _react.default.createElement("div", {
        className: "smart-start-cta-banner fixed-banner"
      }, _react.default.createElement("div", {
        className: "smart-start-banner-item"
      }, _react.default.createElement("h3", {
        className: "uppercase"
      }, _react.default.createElement("a", {
        href: "feedback"
      }, "Send us your feedback ", _react.default.createElement("span", {
        className: "glyphicon glyphicon-arrow-right"
      }))), _react.default.createElement("div", {
        className: "image-wrap"
      }, _react.default.createElement("div", {
        className: "image"
      }, _react.default.createElement("img", {
        src: "/admin/platform/plugins/com.sightworks.5.Channel.instance.marketing/resources/images/new-home/social-icons.png"
      }))))), _react.default.createElement("div", {
        className: "grey-products-banner"
      }, _react.default.createElement("div", {
        className: "inner-content"
      }, _react.default.createElement("div", {
        className: "new-flag",
        style: {
          backgroundImage: "url(/admin/platform/plugins/com.sightworks.5.Channel.instance.marketing/resources/images/pink-flag.png)"
        }
      }, _react.default.createElement("p", null, "New")), _react.default.createElement("p", null, "Select products online and pick up at one of our convenient locations"))), _react.default.createElement("div", {
        className: _classList.default.join('product-list-stack', this.state.mobileNavOpen ? 'mobile-nav-enter' : '')
      }, _react.default.createElement("nav", {
        className: "product-nav",
        ref: this.gotNav
      }, _react.default.createElement("header", {
        className: "mobile-nav-header"
      }, _react.default.createElement("a", {
        className: "mobile-nav-button",
        onClick: this.mobileNavToggle
      }), "Categories"), _react.default.createElement("section", {
        className: "product-search"
      }, _react.default.createElement("header", null, "Search"), _react.default.createElement("form", {
        className: _classList.default.join('search-box', this.searchQuery ? 'has-search' : ''),
        onSubmit: function onSubmit(event) {
          event.preventDefault();

          _this9.createSearchGroup(function (group) {
            return _this9.selectGroup(group);
          });
        }
      }, _react.default.createElement("input", {
        type: "text",
        name: "search",
        value: this.searchQuery,
        onChange: function onChange(event) {
          return _this9.setSearchQuery(event.target.value);
        }
      }), _react.default.createElement("button", {
        className: "submit",
        type: "submit",
        onClick: function onClick(event) {
          event.preventDefault();

          _this9.createSearchGroup(function (group) {
            return _this9.selectGroup(group);
          });
        }
      }, _react.default.createElement("span", {
        className: "glyphicon glyphicon-search"
      })))), this.topGroups.map(function (group) {
        return _react.default.createElement("section", {
          key: group.id
        }, _react.default.createElement("header", null, group.title), _react.default.createElement("ul", null, _this9.childGroups(group.id).map(function (node) {
          return _react.default.createElement("li", {
            key: node.id,
            className: _this9.state.selectedGroup == node.id ? 'active' : ''
          }, _react.default.createElement("a", {
            href: node.id == _this9.props.defaultGroup ? "shop" : "shop/".concat(group.seo_url, "/").concat(node.seo_url),
            onClick: function onClick(event) {
              event.preventDefault();

              _this9.selectGroup(node);
            }
          }, node.title));
        })));
      })), _react.default.createElement("section", {
        className: "productContent",
        ref: this.gotProductContent
      }, this.previousDisplay ? _react.default.createElement("section", {
        className: "previousProductContent",
        ref: this.fadeOutPrevious
      }, this.previousDisplay) : null, this.display)));
    }
  }, {
    key: "setSearchQuery",
    value: function setSearchQuery(value) {
      this.setState({
        searchText: value
      });
    }
  }, {
    key: "fadeOutPrevious",
    value: function fadeOutPrevious(node) {
      var _this10 = this;

      if (!node) return;
      var A = new _animationHelper.default(300, 'ease', function (position) {
        node.style.opacity = 1 - position;
      }, function () {
        _this10.setState({
          previousGroup: null
        });
      });
      A.start();
    }
  }, {
    key: "selectGroup",
    value: function selectGroup(group, force) {
      if (!force && this.state.previousGroup) return;
      var addGroups = {};
      var addState = {};

      if (!this.state.groups[group.id]) {
        addGroups[group.id] = group;
        if (group.isSearch) addState.searchText = group.searchText;
      }

      this.setState(function (state) {
        return Object.assign(addState, {
          previousGroup: null,
          // state.selectedGroup,
          selectedGroup: group.id,
          groups: Object.assign(addGroups, state.groups),
          mobileNavOpen: false
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevPrpos, prevState) {
      if (window.history) {
        if (window.history.state && window.history.state.id == this.group.id) return;
        var path = 'shop';
        var groupPath = [];
        var group = this.group;

        if (!group.isSearch && group.id != this.props.defaultGroup) {
          while (group) {
            groupPath.unshift(group.seo_url);
            group = this.state.groups[group.parent_group_id];
          }
        }

        path += '/' + groupPath.join('/');
        path = path.split('/').filter(function (v) {
          return !!v;
        }).join('/');
        var b = document.querySelector('base').href;
        if (b[b.length - 1] != '/') b += '/';
        b += path;

        if (this.group.isSearch) {
          b += "?q=".concat(encodeURIComponent(this.group.searchText));
        }

        history.pushState({
          id: this.group.id
        }, this.group.title, b);
      }

      if (this.state.selectedGroup != prevState.selectedGroup) {
        this.scrollIntoView();
      }
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView() {
      var E = document.scrollingElement || document.documentElement;
      var start = E.scrollTop;

      var topOf = function topOf(node) {
        return node.offsetTop + (node.offsetParent ? topOf(node.offsetParent) : 0);
      };

      var end = topOf(this.productContent) - document.querySelector('#navScroll').getBoundingClientRect().bottom;
      var delta = start - end;
      var A = new _animationHelper.default(300, 'ease', function (percent) {
        return E.scrollTop = start - delta * percent;
      }, function () {});
      A.start();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (window.history) {
        if (window.history.state && window.history.state.id && window.history.state.id != this.state.group) {
          var tgtGroup = this.state.groups[window.history.state.id];

          if (!tgtGroup && window.history.state.id.startsWith('search:')) {
            tgtGroup = this.getSearchGroup(window.history.state.id.substring('search:'.length));
          }

          this.selectGroup(tgtGroup, true);
        }

        if (!window.history.state) {
          history.replaceState({
            id: this.group.id
          }, this.group.title, location.href);
        }

        window.addEventListener('popstate', this.popState);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('popstate', this.popState);
    }
  }, {
    key: "popState",
    value: function popState(event) {
      if (event.state) {
        if (event.state.id != this.state.group) {
          var tgtGroup = this.state.groups[event.state.id];

          if (!tgtGroup && event.state.id.startsWith('search:')) {
            tgtGroup = this.getSearchGroup(event.state.id.substring('search:'.length));
          }

          this.selectGroup(tgtGroup, true);
        }
      }
    }
  }, {
    key: "group",
    get: function get() {
      return this.state.groups[this.state.selectedGroup];
    }
  }, {
    key: "topGroups",
    get: function get() {
      return this.childGroups(null);
    }
  }, {
    key: "display",
    get: function get() {
      return _react.default.createElement(ProductList, {
        top: true,
        groups: this.state.groups,
        group: this.group.id,
        mobileNavToggle: this.mobileNavToggle
      });
    }
  }, {
    key: "previousDisplay",
    get: function get() {
      return null;
      if (this.state.previousGroup) return _react.default.createElement(ProductList, {
        top: true,
        groups: this.state.groups,
        group: this.state.previousGroup,
        mobileNavToggle: this.mobileNavToggle
      });
      return null;
    }
  }, {
    key: "searchQuery",
    get: function get() {
      return this.state.searchText || "";
    }
  }], [{
    key: "getSearchGroup",
    value: function getSearchGroup(query) {
      var searchGroup = {
        id: "search:".concat(query),
        parent_group_id: null,
        display_order: -1,
        isSearch: true,
        file_name: "",
        title: "Search: ".concat(query),
        searchText: query,
        seo_url: ""
      };
      return searchGroup;
    }
  }]);
  return App;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "mobileNavToggle", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "mobileNavToggle"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotPageHeader", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotPageHeader"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotNav", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotNav"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotProductContent", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotProductContent"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "scrollIntoView", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "scrollIntoView"), _class.prototype)), _class);
exports.default = App;